<template>
  <span v-if="visible" class="container">
    <span class="hidden-xs-only">
      <v-btn to="/" color="#787779" small fab title="Home Menu"
        ><img width="32px" :src="require('../assets/white_star_house.png')"
      /></v-btn>
      <span v-if="moduleName">
        <v-icon>chevron_right</v-icon>
        <v-menu offset-y v-if="modules.length">
          <v-btn slot="activator" flat fab small>
            <!-- <v-icon v-if="folderIcon" small>{{ folderIcon }}</v-icon>
            {{ folderName }}-->
            {{ moduleName }}
          </v-btn>
          <v-list>
            <v-list-tile v-for="(item, index) in modules" :key="index" @click="moduleChange(item)">
              <v-list-tile-title>
                <!-- <v-icon v-if="item.icon">{{ item.icon }}</v-icon> -->
                {{ item.name }}</v-list-tile-title
              >
            </v-list-tile>
          </v-list>
        </v-menu>
      </span>
      <span v-if="folderName">
        <v-icon>chevron_right</v-icon>
        <v-menu offset-y v-if="folders.length">
          <v-btn slot="activator" flat small>
            <v-icon v-if="folderIcon" small>{{ folderIcon }}</v-icon>
            {{ folderName }}
          </v-btn>
          <v-list>
            <v-list-tile
              v-for="(item, index) in folders"
              :key="index"
              :to="item.firstPath"
              :disabled="!item.firstPath"
            >
              <v-list-tile-title>
                <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
                {{ item.folder }}</v-list-tile-title
              >
            </v-list-tile>
          </v-list>
        </v-menu>
      </span>
    </span>
    <v-icon>chevron_right</v-icon>
    <v-menu offset-y small>
      <v-btn slot="activator" flat small color="white" :to="$route.path">
        <v-icon v-if="pageIcon" small>{{ pageIcon }}</v-icon>
        {{ pageName }}
      </v-btn>
      <v-list>
        <v-list-tile
          v-for="(subItem, index) in subItems"
          :key="index"
          :to="subItem.to"
          :disabled="!subItem.to"
          @click="onPageMenuClick($route.path, subItem.to)"
        >
          <v-list-tile-title>
            <v-icon v-if="subItem.icon">{{ subItem.icon }}</v-icon>
            {{ subItem.text }}</v-list-tile-title
          >
        </v-list-tile>
      </v-list>
    </v-menu>
  </span>
</template>

<script>
import {folderIcons, getItemsFromFolderAndMarket} from '../helpers/menu-helpers'
import {levenshteinDistance} from '../helpers/string-helpers'
import {mapGetters} from 'vuex'
import markets from '../enums/market'

export default {
  computed: {
    ...mapGetters({marketId: 'app/marketId'}),
    pageName() {
      const subItem = this.subItems.find(x => x.to == this.$route.path)
      return subItem != null && subItem.text ? subItem.text : this.$route.meta.text
    },
    pageIcon() {
      return this.$route.meta.icon
    },
    folderName() {
      const [, name] = this.$route.path.match(/\/(.*)\//) || []
      if (name) {
        return name.toUpperCase()
      }
      return ''
    },
    folderIcon() {
      const folderName = this.folderName
      if (folderName) {
        return this.folders.find(x => x.folder == this.folderName).icon
      }
      return null
    },
    visible() {
      return this.$route.name != 'home' && this.isLoggedIn
    },
    moduleName() {
      const selectedMarket = this.marketId
      const marketCode = this.hasMarkets
        ? this.getKeyByValue(this.$route.meta.markets, selectedMarket)
        : 'Base'
      return this.hasMarkets ? marketCode : this.$route.meta.module
    },
    hasMarkets() {
      return 'markets' in this.$route.meta
    },
    itemsForModuleAndRole() {
      let clientMarkets = Object.keys(this.clientMarkets)
      return this.itemsForRole.filter(
        x =>
          (x.meta.markets && clientMarkets.some(r => Object.keys(x.meta.markets).includes(r))) ||
          x.meta.module == this.moduleName,
      )
    },
    marketItems() {
      const currentMarket = this.getKeyByValue(this.clientMarkets, this.marketId)
      const marketItems = this.itemsForModuleAndRole.filter(
        x =>
          x.meta &&
          ((x.meta.markets && Object.keys(x.meta.markets).includes(currentMarket)) ||
            x.meta.module == currentMarket),
      )
      return marketItems
    },
    modules() {
      const marketNames = Object.keys(this.clientMarkets)
      marketNames.push(marketNames.splice(marketNames.indexOf('Base'), 1)[0])

      return marketNames.map(m => {
        const firstPath = this.itemsForRole.find(
          item =>
            item.meta &&
            (item.meta.module == m || (item.meta.markets && item.meta.markets[m] != null)),
        )
        return {name: m, firstPath: firstPath && firstPath.path}
      })
    },
    folders() {
      const firstPathForFolder = this.marketItems.reduce((acc, item) => {
        const folder = item.path.match(/\/(.*)\//)[1].toUpperCase()
        if (!acc[folder]) {
          acc[folder] = item.path
        }
        return acc
      }, {})

      return Object.keys(firstPathForFolder).map(folder => ({
        icon: folderIcons[folder],
        folder,
        firstPath: firstPathForFolder[folder],
      }))
    },
    subItems() {
      const currentMarket = this.getKeyByValue(this.clientMarkets, this.marketId)
      const folderName = this.folderName
      if (folderName) {
        return getItemsFromFolderAndMarket(
          this.marketItems,
          '/' + folderName.toLowerCase(),
          currentMarket,
        )
      }

      return this.folders.map(({folder, firstPath, icon}) => ({
        text: folder,
        to: firstPath,
        icon,
      }))
    },

    clientMarkets() {
      let clientMarkets = this.userClientMarkets.reduce((acc, item) => {
        acc[item.market] = item.marketId
        return acc
      }, {})

      return clientMarkets
    },
    ...mapGetters({isLoggedIn: 'authentication/isLoggedIn'}),
    ...mapGetters({appFolder: 'app/folders'}),
    ...mapGetters({itemsForRole: 'app/pathsForCurrentRole'}),
    ...mapGetters({visibleModules: 'app/visibleModules'}),
    ...mapGetters({userClientMarkets: 'authentication/userClientMarkets'}),
  },
  methods: {
    getKeyByValue(object, value) {
      const keys = Object.keys(object)
      let key = keys.find(key => object[key] === value)
      return key === undefined ? keys[0] : key
    },
    onPageMenuClick(currentPath, path) {
      if (currentPath == path) {
        setTimeout(() => this.$router.replace({path, hash: 'c'}), 0)
        setTimeout(() => this.$router.replace({path, hash: ''}), 0)
      }
    },
    moduleChange(e) {
      const routeMarkets = this.$route.meta.markets
      const marketId = markets[e.name]
      this.$store.dispatch('app/setMenuMarket', {marketId})

      if (this.hasMarkets && Object.keys(routeMarkets).includes(e.name)) {
        const path = this.$router.path
        setTimeout(() => this.$router.replace({path, hash: e.name}), 0)
        setTimeout(() => this.$router.replace({path, hash: ''}), 0)
      } else {
        const [closestItem] = this.itemsForRole
          .filter(
            p => p.meta.module === e.name || (p.meta.markets && p.meta.markets[e.name] != null),
          )
          .map(p => ({
            path: p.path,
            distance: levenshteinDistance(p.path, this.$router.currentRoute.path),
          }))
          .sort((a, b) => a.distance - b.distance)
        if (closestItem) {
          const path = closestItem.distance > 10 ? e.firstPath : closestItem.path
          this.$router.push(path)
        } else {
          const {path, hash} = this.$route
          this.$router.push({path, hash: hash ? '' : 'c'})
        }
      }
    },
  },
}
</script>
<style scoped>
.pageName {
  font-size: 14px;
}
.container {
  user-select: none;
}
</style>
